import React from 'react';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type Props = {
    onClick: () => void;
    disabled?: boolean;
    className?: string;
    id?: string;
};

/**
 * Same visual as mapping TopBar Analysis button, without BETA badge.
 */
const AnalysisEntryButton = ({ onClick, disabled, className = '', id = 'collectAnalysisButton' }: Props) => {
    const { t } = useTranslation();

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={`relative inline-flex items-center gap-2 py-2 px-4 rounded-full flex-shrink-0 ${className}`.trim()}
            style={{ border: '1px solid var(--tenant-primary, #017d7c)', background: '#fff' }}
            id={id}
        >
            <Sparkles className="rotate-icon" size={22} aria-hidden style={{ color: 'var(--tenant-primary, #017d7c)' }} />
            <span className="font-medium" style={{ color: '#1A1A1A' }}>
                {t('features.swimlane.analysis')}
            </span>
        </button>
    );
};

export default AnalysisEntryButton;
